import EditModal from './EditModal';

export { EditModal };
export default EditModal;
